type ProgramItemGroupIconProps = {
  size?: number
  color?: string
}

/** CDN の種別アイコン（workgroup.svg 等）と同じ線色（colorPalette に該当色なし） */
const DEFAULT_COLOR = '#888888'
/** CDN の種別アイコン（workgroup.svg 等）と同じ内部塗り色 */
const INNER_FILL = '#F2F2F2'

/**
 * プログラム配下のグループを表すアイコン（AccountTree モチーフ）。
 * 配下のプロジェクトを束ねる構造を表現する。
 * 種別アイコン（assets/icons/wbs-item-type/*.svg）と視覚的な重さを合わせるため、
 * 細い輪郭線＋薄い内部塗り（#F2F2F2）で描画する。
 * AG Grid の全行に描画されるセルでも使うため、emotion を介する SvgIcon ではなく
 * 生 SVG で軽量に描画する。
 */
export const ProgramItemGroupIcon = ({
  size = 16,
  color = DEFAULT_COLOR,
}: ProgramItemGroupIconProps) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="none"
    style={{ flexShrink: 0 }}
  >
    {/* 接続線 */}
    <path
      d="M7 5.5h3.5M10.5 4v12.5M10.5 4H13M10.5 16.5H13"
      stroke={color}
      strokeWidth="1"
    />
    {/* 左のボックス */}
    <rect
      x="1.5"
      y="3.5"
      width="5.5"
      height="4"
      rx="0.8"
      fill={INNER_FILL}
      stroke={color}
      strokeWidth="1"
    />
    {/* 右上のボックス */}
    <rect
      x="13"
      y="2"
      width="5.5"
      height="4"
      rx="0.8"
      fill={INNER_FILL}
      stroke={color}
      strokeWidth="1"
    />
    {/* 右下のボックス */}
    <rect
      x="13"
      y="14.5"
      width="5.5"
      height="4"
      rx="0.8"
      fill={INNER_FILL}
      stroke={color}
      strokeWidth="1"
    />
  </svg>
)
